import api from "./api";

const VendorService = {
  // Create a new vendor
  create: async (data) => {
    const res = await api.post("/vendors/save", data);
    return res.data;
  },

  // // Get all vendors
  // getAll: async () => {
  //   const res = await api.get("/vendors/getAll");
  //   return res.data;
  // },

  // // Get active vendors
  // getActiveVendors: async () => {
  //   const res = await api.get("/vendors/getActive");
  //   return res.data;
  // },

  // Get active vendors with pagination
  getActiveVendors: async (page = 1, limit = 20) => {
    const res = await api.get(`/vendors/getActive?page=${page}&limit=${limit}`);
    return res.data;
  },


  // Get vendors with pagination, search, and category filter
  getAll: async (page = 1, limit = 20, search = "", vendorCategoryId = "") => {
    const res = await api.get(`/vendors/getAll?page=${page}&limit=${limit}&search=${search}&vendorCategoryId=${vendorCategoryId}`);
    return res.data;
  },

  // Get vendor
  getById: async (id) => {
    const res = await api.get(`/vendors/getById/${id}`);
    return res.data;
  },

  // Update vendor
  update: async (id, data) => {
    const res = await api.put(`/vendors/updateVendor/${id}`, data);
    return res.data;
  },

  // Delete vendor
  delete: async (id) => {
    const res = await api.delete(`/vendors/${id}`);
    return res.data;
  },

  updateStatus: async (id) => {
    const res = await api.put(`/vendors/updateStatus/${id}`);
    return res.data;
  },


  getByCategory: async (vendorCategoryId) => {
    const res = await api.get(`/vendors/getByCategory/${vendorCategoryId}`);
    return res.data;
  },

  getByCompanyId: async (companyId) => {
    const res = await api.get(`/vendors/getByCompany/${companyId}`);
    return res.data;
  },

};

export default VendorService;
